module.exports = __webpack_public_path__ + "assets/img/9_448_big.1561afa3.jpg";